import { ColorTokens, View } from "tamagui";

import { GlowCircle } from "./GlowCircle";

export type GlowTripleProps = {
  gradientColors: ColorTokens[] | string;
  size?: number;
};

export const GlowTriple = ({ size = 170, gradientColors }: GlowTripleProps) => {
  const firstCircleSize = size / 1.3;
  const secondCircleSize = size / 1.6;
  const thirdCircleSize = size / 1;

  return (
    <View width={size} height={size} position="relative">
      <GlowCircle
        position="absolute"
        top={0}
        left={0}
        size={firstCircleSize}
        color={gradientColors[0]}
        opacity={0.2}
        gradientSize={`${firstCircleSize / 2}px ${firstCircleSize / 2}px`}
        gradientOrigin="50% 50%"
      />
      <GlowCircle
        position="absolute"
        top={0}
        right={0}
        size={secondCircleSize}
        color={gradientColors[1] || gradientColors[0]}
        opacity={0.25}
        gradientSize={`${secondCircleSize / 2}px ${secondCircleSize / 2}px`}
        gradientOrigin="50% 50%"
      />
      <GlowCircle
        position="absolute"
        bottom={0}
        left={size / 2 - thirdCircleSize / 2}
        size={thirdCircleSize}
        color={gradientColors[2] || gradientColors[0]}
        opacity={0.15}
        gradientSize={`${thirdCircleSize / 2}px ${thirdCircleSize / 2}px`}
        gradientOrigin="50% 50%"
      />
    </View>
  );
};
